import React from 'react';
import './BottomBar.scss';
import { DefaultBottomBar } from './DefaultBottomBar';

export type BottomBarProps = {
    showMenu: boolean;
    setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
};

export const BottomBar: React.FC<BottomBarProps> = ({ showMenu, setShowMenu }) => {
    return <DefaultBottomBar showMenu={showMenu} setShowMenu={setShowMenu} />;
};
